var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEVentilationDamperRoomMotorized = function SvgEVentilationDamperRoomMotorized(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 115,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,105c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M260,104c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.36,111.65l1.64,4.36,1.64-4.36h1.28v5.69h-.98v-1.88l.1-2.51-1.68,4.38h-.71l-1.68-4.38.1,2.5v1.88h-.98v-5.69h1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 132,
    width: 22,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,133v26h-20v-26h20M271,132h-22v28h22v-28h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 242.96,
    y: 145.5,
    width: 34.08,
    height: 1,
    transform: "translate(-14.76 261.86) rotate(-52.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 146,
    r: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 126,
    width: 2,
    height: 6
  }))));
};
export default SvgEVentilationDamperRoomMotorized;